import { render, staticRenderFns } from "./bidding-release.vue?vue&type=template&id=83e5b462&scoped=true"
import script from "./bidding-release.vue?vue&type=script&lang=js"
export * from "./bidding-release.vue?vue&type=script&lang=js"
import style0 from "./bidding-release.vue?vue&type=style&index=0&id=83e5b462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e5b462",
  null
  
)

export default component.exports